export const performanceData = [
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Counseling Session',
        sessionType: 'Teleconsult',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },
    {
        sessionTitle:'Online Psychotherapy Session',
        sessionType: 'Walk-in',
        provider: 'James McCharan',
        timeStamp: 'Jan 01 2021 | 10:00 - 12:45',
        amountPaid: '$2,000'
    },

]